
import { Col, Form, Input, Row, Select } from "antd";

const TNADepartmentFields = ({ initialTableData }) => {

return (
    <>
      <Col span={6}>
        <Form.Item label="Department Title" name="title">
          <Input placeholder="Write Department Title ..." size="small" />
        </Form.Item>
      </Col>
    </>
  );
};

export default TNADepartmentFields;
